/**
 * Creates an option Tag
 * @param value
 * @param text
 * @return {*}
 */
 export function createOption(value: string, text: string): HTMLOptionElement {
    const option = document.createElement("option");
    option.value = value;
    option.text = text;
    return option;
}

/**
 * create a video tag element
 * @param className
 * @param mute
 * @return {*}
 */
export function createVideoElement(className: string, mute: boolean): HTMLVideoElement {
    const videoEl = document.createElement("video");
    videoEl.setAttribute("playsinline", "true");

    if (mute) {
        videoEl.setAttribute("muted", "true");

        // fallback incase above attribute don't work
        videoEl.muted = true;
    }

    videoEl.setAttribute("autoplay", "true");
    videoEl.classList.add(className);
    return videoEl;
}

/**
 * swap child element position
 * @param {Element} child1
 * @param {Element} child2
 */
export function swapChildElements(child1: any, child2: any): void {
    if (child1 && child2) {
        child1.parentNode.insertBefore(child2, child1);
    }
}
